import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Heading } from 'ui';
const ErrorMessage = () => {
  const $ = _c(11);
  const t = useTranslations("content.feedback");
  let t0;
  if ($[0] !== t) {
    t0 = t("page_error_heading");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Heading as="h2" variant="h5">{t0}</Heading>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t.rich("page_error_body", {
      contact: _temp,
      email: _temp2
    });
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <p className="mt-2 font-normal typography-subtitle-1">{t2}</p>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className="container px-3 pt-8 mx-auto text-center">{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export { ErrorMessage };
function _temp(chunks) {
  return <a className="underline" href="https://www.byway.travel/contact">{chunks}</a>;
}
function _temp2(chunks_0) {
  return <a className="underline" href="mailto:hello@byway.travel">{chunks_0}</a>;
}